import { configureStore } from '@reduxjs/toolkit';

// slices
import login from './slices/login.slice';
import selection from './slices/selection.slice';

export const store = configureStore({
  reducer: {
    login,
    selection,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== 'production',
});
